import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

export class RestServiceEndpoint {
  constructor(
    private method: string,
    private url: string,
    private params?: string[],
    private body?: string
  ) {}
  getUrl(): string {
    let urlParams;
    if (this.params != null || this.params !== undefined) {
      urlParams = this.params.join('?');
      return `${this.url}?${urlParams}`;
    }

    return `${this.url}`;
  }
  getMethod(): string {
    return this.method;
  }

  setParams(params: string[]) {
    this.params = params;
  }

  setBody(body: string) {
    this.body = body;
  }
}

@Injectable()
export class RestService {
  public static TEST_BASE_URL = 'http://test.qmedical.ro/testqmedical';
  public static BASE_URL = 'https://members.qmedical.ro/qmedical';


  public endPoints = {
    LOGIN: new RestServiceEndpoint(
      'POST',
      `${RestService.BASE_URL}/seam/resource/rest/authentification`
    ),
    LOGOUT: new RestServiceEndpoint(
      'DELETE',
      `${RestService.BASE_URL}/seam/resource/rest/authentification`
    ),
    PATIENT_LIST: new RestServiceEndpoint(
      'GET',
      `${RestService.BASE_URL}/seam/resource/rest/patient`
    ),
    APTITUDE_FILE: new RestServiceEndpoint(
      'GET',
      `${RestService.BASE_URL}/seam/resource/rest/aptitudeFile/ID`
    ),
    INVOICE: new RestServiceEndpoint(
      'GET',
      `${RestService.BASE_URL}/seam/resource/rest/invoice`
    )
  };

  constructor() {}

  test(): void {
    this.endPoints.PATIENT_LIST.setParams(['token=USER_TOKEN']);
    console.log(this.endPoints.PATIENT_LIST.getUrl());
  }
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/services/rest.service.ts